export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/afters/resources/mounted.js